import { Routes } from '@angular/router';

import { SigninComponent } from './components/signin/signin.component';

export const authenticationRoutes: Routes = [
  { path: 'signin', pathMatch: 'full', component: SigninComponent },
  { path: 'logout', pathMatch: 'full', redirectTo: 'signin' }
];
